"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Engage = void 0;

Engage = function () {
  function Engage() {}

  (0, _jquery2.default)(".engage-something").on("click", function (e) {
    var $this = void 0;
    var theEngaged = void 0;
    e.preventDefault();
    $this = (0, _jquery2.default)(this);
    theEngaged = $this.attr("href");
    (0, _jquery2.default)(theEngaged).removeClass("hidden");
    (0, _jquery2.default)("html,body").stop().animate({
      scrollTop: (0, _jquery2.default)(theEngaged).offset().top
    }, 500);
    return $this.addClass("hidden");
  });

  (0, _jquery2.default)(".toggle-something").on("click", function (e) {
    var $this = void 0;
    var theEngaged = void 0;
    e.preventDefault();
    $this = (0, _jquery2.default)(this);
    theEngaged = $this.attr("data-engage");
    (0, _jquery2.default)(theEngaged).toggleClass("hidden");
    return (0, _jquery2.default)("*[data-engage=\"" + theEngaged + "\"]").find("span").toggleClass("hidden");
  });

  return Engage;
}();

exports.default = new Engage();